// extracted by mini-css-extract-plugin
export default {"searchFromCon":"searchFromCon--cFyId","changeStatus":"changeStatus--CYJJN","link":"link--oA8bE","imgWrapper":"imgWrapper--Sfr4W","markerAnimationScale":"markerAnimationScale--KfaXL"};